import React, { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface MetricsCursorState {
  /** Current crosshair x-axis value (null when not hovering) */
  cursorX: number | null;
  setCursorX: (x: number | null) => void;
  /** Current brush zoom range (null = full range) */
  xRange: [number, number] | null;
  setXRange: (range: [number, number] | null) => void;
  /** uPlot cursor sync key — all charts sharing this key sync crosshairs */
  syncKey: string;
}

const MetricsCursorContext = createContext<MetricsCursorState | null>(null);

export function MetricsCursorProvider({ children }: { children: ReactNode }) {
  const [cursorX, setCursorXRaw] = useState<number | null>(null);
  const [xRange, setXRangeRaw] = useState<[number, number] | null>(null);

  const setCursorX = useCallback((x: number | null) => setCursorXRaw(x), []);
  const setXRange = useCallback((r: [number, number] | null) => setXRangeRaw(r), []);

  return (
    <MetricsCursorContext.Provider
      value={{ cursorX, setCursorX, xRange, setXRange, syncKey: "metrics-sync" }}
    >
      {children}
    </MetricsCursorContext.Provider>
  );
}

export function useMetricsCursor(): MetricsCursorState {
  const ctx = useContext(MetricsCursorContext);
  if (!ctx) throw new Error("useMetricsCursor must be used within MetricsCursorProvider");
  return ctx;
}
